import React, { useEffect, useState } from 'react';
import { X, CheckCircle2 } from 'lucide-react';
const socialProofData = [{
  name: 'Camila R.',
  city: 'Buenos Aires',
  time: '3 min'
}, {
  name: 'Mateo G.',
  city: 'Bogotá',
  time: '5 min'
}, {
  name: 'Sofía T.',
  city: 'Ciudad de México',
  time: '7 min'
}, {
  name: 'Joaquín M.',
  city: 'Santiago',
  time: '12 min'
}, {
  name: 'Valentina B.',
  city: 'Lima',
  time: '15 min'
}, {
  name: 'Lucas P.',
  city: 'Córdoba',
  time: '18 min'
}, {
  name: 'Isabella S.',
  city: 'Medellín',
  time: '22 min'
}, {
  name: 'Diego C.',
  city: 'Rosario',
  time: '25 min'
}, {
  name: 'Martina L.',
  city: 'Quito',
  time: '28 min'
}, {
  name: 'Tomás F.',
  city: 'Montevideo',
  time: '31 min'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const initialDelay = setTimeout(() => setVisible(true), 5000);
    return () => clearTimeout(initialDelay);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed || !visible) return;
    const hideTimer = setTimeout(() => setVisible(false), 5500);
    return () => clearTimeout(hideTimer);
  }, [visible, dismissed]);
  useEffect(() => {
    if (dismissed || visible) return;
    const showTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % socialProofData.length);
      setVisible(true);
    }, 9000);
    return () => clearTimeout(showTimer);
  }, [visible, dismissed]);
  if (dismissed) return null;
  const person = socialProofData[currentIndex];
  return <div className={`fixed bottom-4 left-4 z-50 max-w-sm transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0 pointer-events-none'}`} data-id="element-277">
      <div className="bg-white border border-navy-100 rounded-2xl p-4 pr-10 shadow-[0_20px_50px_-10px_rgba(7,27,77,0.25)] relative" data-id="element-278">
        <button onClick={() => setDismissed(true)} className="absolute top-3 right-3 text-ink-400 hover:text-navy-900 transition-colors" aria-label="Cerrar" data-id="element-279">
          <X className="w-4 h-4" data-id="element-280" />
        </button>
        <div className="flex items-start gap-3" data-id="element-281">
          <div className="w-10 h-10 rounded-full bg-cyan-500/10 flex items-center justify-center shrink-0 border border-cyan-500/30" data-id="element-282">
            <CheckCircle2 className="w-5 h-5 text-cyan-600" data-id="element-283" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-284">
            <p className="text-sm text-ink-700" data-id="element-285">
              <span className="font-bold text-navy-900" data-id="element-286">{person.name}</span>{' '}
              <span className="text-ink-500" data-id="element-287">desde {person.city}</span>
            </p>
            <p className="text-sm text-ink-500 mt-1" data-id="element-288">
              Acaba de obtener acceso al{' '}
              <span className="text-navy-900 font-semibold" data-id="element-289">
                Mega Pack · Anatomía
              </span>
            </p>
            <p className="text-xs text-ink-400 mt-2 flex items-center gap-1.5 font-medium" data-id="element-290">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 inline-block animate-pulse" data-id="element-291"></span>
              COMPRA VERIFICADA · hace {person.time}
            </p>
          </div>
        </div>
      </div>
    </div>;
}